import {
    useEffect,
    useState
} from "react";
import {
    INTERNAL_ZIP_INFO_API_ENDPOINT
} from "../Constants";  
import config from "../../config/config"; 

function ZipInfos({
    phoneNumber
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState();

    async function fetchData() {
        const axios = require("axios").default;
        try { 
            let url = INTERNAL_ZIP_INFO_API_ENDPOINT + phoneNumber;

            const response = await axios.get(`${url}`, {
                headers: {
                    "Access-Control-Allow-Origin": "no-cors",
                    ApiKey: config.API_KEY,
                },
            });
            setMessage(response.data);
        } catch (error) {
            setMessage(`Error : ${JSON.stringify(error.data)} `);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        setIsLoading(true);
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phoneNumber]);
    
    return (
        <div style={{ 
            margin: '5px 0', 
            textAlign: 'center', 
            lineHeight: '1.5',
            padding: '10px',
            borderRadius: '4px',
            fontWeight: '700',
            background: '#f9f9f9',
            border: '1px solid #e0e0e0'
        }}>
            <span style={{ 
                color: '#e63946', 
                fontWeight: 'bold'
            }}>Location Information: </span>
            {isLoading ? (
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <div className="loader loader-small" style={{ marginRight: '8px' }}></div> Loading...
                </span>
            ) : (
                <span>
                    <span style={{color: "#e63946"}}>Zip:</span> {message?.zip ? message.zip : "N/A"}{", "}
                    <span style={{color: "#e63946"}}>City:</span> {message?.city ? message.city : "N/A"}{", "}
                    <span style={{color: "#e63946"}}>County:</span> {message?.county ? message.county : "N/A"}{", "}
                    <span style={{color: "#e63946"}}>State:</span> {message?.state ? message.state : "N/A"}
                </span>
            )}
        </div>
    );
}
export default ZipInfos;